import {gql, useQuery} from '@apollo/client';
import {GetAllAdvisers} from '../schema-types/GetAllAdvisers';
import {STAFF} from '../graphql/fragments';

export const GET_ALL_ADVISERS = gql`
  ${STAFF}
  query GetAllAdvisers {
    staff(staffType: "adviser") {
      ...Staff
    }
  }
`;

export const useAllAdvisers = () => {
  const {data, loading, error} = useQuery<GetAllAdvisers>(GET_ALL_ADVISERS);

  const allAdvisers = (data?.staff || []).filter(Boolean);

  return {
    allAdvisers,
    loading,
    error,
  };
};
